import React from 'react';
import styled from 'styled-components';
import { Text, theme } from 'components';

interface TableEntryProps {
  value: string;
  breakAll?: boolean;
}

const TableEntry = ({ value, breakAll }: TableEntryProps) => (
    <Container>
      <StyledText $breakAll={breakAll}>{value}</StyledText>
    </Container>
  );

export default TableEntry;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

const StyledText = styled(Text)<{ $breakAll?: boolean }>`
  font-size: 12px;
  color: ${theme.gray10};
  white-space: pre-line;
  ${({ $breakAll }) => $breakAll && '  word-break: break-all;'}
`;
